<template>
  <simpleDiag
    :title="dialogTitle"
    :isShow="isShow"
    width="400px"
    @close="close"
    @confirm="confirm">
    <div class="text-center" :class = "{'diag_del': dealType === '1'}" v-html="dialogTxt"></div>
  </simpleDiag>
</template>
<script>
import simpleDiag from '@/components/dialogs/simpleDiag'
export default {
  components: { simpleDiag },
  props: {
    isShow: Boolean,
    dealSingleData: Object,
    dealType: String
  },
  methods: {
    close() {
      this.$emit('close')
    },
    confirm() {
      this.$emit('confirm')
    }
  },
  computed: {
    dialogTitle() {
      return ['', '删除提示', '批量删除', '还原', '批量还原'][this.dealType]
    },
    dialogTxt() {
      if (this.dealType === '1' || this.dealType === '3') {
        return `确定${this.dialogTitle.substring(0, 2)}<span class="company-name">${this.dealSingleData.name}</span>吗？`
      } else if (this.dealType === '2' || this.dealType === '4') {
        return `确定${this.dialogTitle.slice(-2)}吗？`
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="scss">
  .company-name {
    color: #DFA338;
    margin: 0 4px;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 240px;
  }
  .text-center {
    text-align: center;
  }
  .ivu-modal {
    top: 0;
  }
</style>
